// removed by extract-text-webpack-plugin
module.exports = {"Base":"CommentCount__Base-1XHWZ","Icon":"CommentCount__Icon-1_WA6","Icon--grey":"CommentCount__Icon--grey-1ATPr CommentCount__Icon-1_WA6","Icon--red":"CommentCount__Icon--red-uZxnL CommentCount__Icon-1_WA6"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CommentCount/CommentCount.css
 ** module id = 626
 ** module chunks = 0
 **/